import { Outlet, useOutlet, useParams } from "react-router-dom";

import AssetDetails from "./AssetDetails";

const Asset = () => {
  const hasChildRoute = useOutlet() !== null;
  const { factoryId, assetId } = useParams<{
    factoryId: string;
    assetId: string;
  }>();

  if (!assetId || !factoryId) {
    return <div>Error: ID is missing</div>;
  }

  return (
    <>
      {!hasChildRoute && (
        <AssetDetails factoryId={factoryId} assetId={assetId} />
      )}
      <Outlet />
    </>
  );
};

export default Asset;
